import { axios } from '~/clients';
import { GET_OWNER_REVIEWS } from '~/constants/endpoints';
import type { OwnerReviewsRequest, OwnerReviewsResponse } from './contracts';

export default function fetchReviews(
  {
    make,
    model,
    pageNumber,
    perPage,
    starRating,
    searchTerm,
    trim,
    year
  }: OwnerReviewsRequest,
  controller: AbortController
) {
  return axios.post<OwnerReviewsResponse>(
    GET_OWNER_REVIEWS,
    {
      from: Math.max(0, pageNumber * perPage - perPage),
      make,
      model,
      search: searchTerm || undefined,
      size: perPage,
      withStarRating: starRating,
      trim,
      year
    },
    { signal: controller.signal }
  );
}
